import { fetcher } from '@commenda/utils';
import { templateVersionsUrl } from './helpers';
import { TDocumentAssemblerSetPlaceholderConstantGenerationValueParams } from './types';

/**
 * Decides that an instruction is not a variable: every occurrence renders this text and the expert is never
 * asked for it. An empty string removes it from the finished document; omitting the value undoes the decision.
 * Only a draft version can be changed, because publishing freezes it.
 */
export const setDocumentAssemblerPlaceholderConstantGenerationValue = async (
  templateId: string,
  versionId: string,
  params: TDocumentAssemblerSetPlaceholderConstantGenerationValueParams
): Promise<Response> =>
  fetcher(
    `${templateVersionsUrl(templateId)}/${versionId}/placeholders/constant-generation-value`,
    { method: 'POST', body: params }
  );
